import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Button, TextField } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import axios from 'axios';

interface IEditPrice {
	title: string;
	open: boolean;
	onClose: () => void;
	id: number;
}

interface IData {
	user: string;
	amount: number;
	for: string;
	created_at: any;
	gateway: string;
	bank_ref_id: number;
	id: number;
	status: number | string;
}

export default function EditPriceModal({ title, open, onClose, id }: IEditPrice) {
	const { t } = useTranslation();
	const [data, setData] = useState<IData>();

	useEffect(() => {
		if (id) {
			axios({
				url: `/admin/payments/${id}`,
				method: 'GET',
			}).then(result => {
				if (result?.data?.success) {
					let resultObj = result?.data?.data;
					let statusText;
					let status = result?.data?.data?.status;
					if (status === 1) {
						statusText = t('payed');
					} else if (status === 0 || status === -1) {
						statusText = t('payment_error');
					} else {
						statusText = t('unknown_status');
					}
					resultObj.status = statusText;
					setData(resultObj);
				} else {
					onClose();
				}
			});
		}
	}, [id]);
	let FormatDate = new Date(data?.created_at).toLocaleDateString('fa-IR');
	return (
		<Dialog open={open} onClose={onClose} className={'w-full'}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent className="flex flex-col gap-3 py-4">
				<TextField label={t('user_name')} value={data?.user ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('amount')} value={data?.amount ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('for')} value={data?.for ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('created_at')} value={FormatDate ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('getaway')} value={data?.gateway ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('bank_ref_id')} value={data?.bank_ref_id ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('unique_payment_identifier')} value={data?.id ?? '__'} variant="outlined" aria-readonly={true} />
				<TextField label={t('status')} value={data?.status ?? '__'} variant="outlined" aria-readonly={true} />
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} variant="outlined">
					{t('cancel')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
